"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

interface TermsTabsProps {
  className?: string;
}

export function TermsTabs({ className }: TermsTabsProps) {
  const pathname = usePathname();

  const tabs = [
    {
      name: "Terms of Use",
      href: "/terms/terms-of-use",
      isActive: pathname === "/terms/terms-of-use",
    },
    {
      name: "Privacy Policy",
      href: "/terms/privacy-policy",
      isActive: pathname === "/terms/privacy-policy",
    },
    {
      name: "Applicant Privacy Notice",
      href: "/terms/applicant-privacy-notice",
      isActive: pathname === "/terms/applicant-privacy-notice",
    },
  ];

  return (
    <div
      className={cn(
        "flex flex-wrap gap-x-8 gap-y-2 border-b border-gray-300 dark:border-gray-700",
        className
      )}
    >
      {tabs.map((tab) => (
        <Link
          key={tab.href}
          href={tab.href}
          className={cn(
            "pb-2 text-sm font-medium transition-colors",
            tab.isActive
              ? "border-foreground text-foreground border-b-2"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {tab.name}
        </Link>
      ))}
    </div>
  );
}
